import * as actionTypes from "../actionTypes";

const initialState = {
    transactionHistoryData: [],
};

const transactionReducer = (state = initialState, actions) => {
    const { payload, type } = actions;

    switch (type) {
        case actionTypes.SET_TRANSACTION_HISTORY: {
            return {
                ...state,
                transactionHistoryData: payload,
            };
        }
        default: {
            return state;
        }
    }
};

export default transactionReducer;
